import { ACTION } from './zone_actions';
import {
  list_reducer,
  update_reducer,
  delete_reducer,
  add_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  filteredCount: 0,
  isLoading: false,
  isCreating: false,
  isEditing: false,
  isDeleting: false,
  isAddingToFloor: false,
  isRemovingFromFloor: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isCreating: false,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isLoading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DUPLICATE}_PENDING`:
      return {
        ...state,
        isDuplicating: true,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isDuplicating: false,
      };
    case `${ACTION.DUPLICATE}_REJECTED`:
      return {
        ...state,
        isDuplicating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isDeleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        isEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isEditing: false,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.ADD_ZONE_TO_FLOOR}_PENDING`:
      return {
        ...state,
        isAddingToFloor: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_ZONE_TO_FLOOR}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        orderedIds: [action.payload.id, ...state.orderedIds],
        isAddingToFloor: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_ZONE_TO_FLOOR}_REJECTED`:
      return {
        ...state,
        isAddingToFloor: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REMOVE_ZONE_FROM_FLOOR}_PENDING`:
      return {
        ...state,
        isRemovingFromFloor: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_ZONE_FROM_FLOOR}_FULFILLED`:
      return {
        ...state,
        orderedIds: state.orderedIds.filter(id => id !== action.payload.id),
        isRemovingFromFloor: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_ZONE_FROM_FLOOR}_REJECTED`:
      return {
        ...state,
        isRemovingFromFloor: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_reducer.js